import React, { useEffect, useState, useCallback } from 'react'
import { useIframeUrlMutation, useLazyGetRenewalAnalyticsOverviewForReportQuery } from '../../app/services/DashBoard/adminDashBoardApi';

const QUESTION_IDS = {
    pieChart: 63,
    expiringTable: 65,
    discontinuationTable: 64,
};

const formatAsOfDate = (date) => {
    const d = date ? new Date(date) : new Date();
    return d.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });
};

const MetabaseIframe = ({ questionId, title, height = 400 }) => {
    const [iframeUrl, setIframeUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [iframeUrlApi] = useIframeUrlMutation();
    

    const fetchIframeUrl = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const requestPayload = {
                QuestionId: questionId,
                params: {},
                expMinutes: 0,
                bordered: false,
                titled: false,
            };
            const response = await iframeUrlApi(requestPayload).unwrap();

            let url = response.iframeUrl;
            const separator = url.includes("?") ? "&" : "?";
            url = `${url}${separator}theme=transparent&bordered=false&titled=false`;

            setIframeUrl(url);
        } catch (err) {
            console.error(err);
            setError("Failed to fetch iframe URL");
        } finally {
            setLoading(false);
        }
    }, [questionId, iframeUrlApi]);

    useEffect(() => {
        fetchIframeUrl();
    }, [fetchIframeUrl]);

    return (
        <div style={{ position: "relative", width: "100%", background: "transparent" }}>
            {loading && <p>Loading {title}...</p>}
            {error && <p style={{ color: "red" }}>{error}</p>}
            {iframeUrl && (
                <iframe
                    src={iframeUrl}
                    width="100%"
                    height={height}
                    frameBorder="0"
                    style={{ border: "none", background: "transparent" }}
                    title={title}
                    allowTransparency="true"
                />
            )}
        </div>
    );
};

const RenewalSummaryStats = ({ data, loading, error }) => {
    debugger
    if (loading) return <p>Loading summary...</p>;
    if (error) return <p style={{ color: "red" }}>{error}</p>;
    if (!data) return null;

    const rows = [
        { label: "Renewals (In-Progress)", value: data.renewalsInProgress, color: "#8BC34A" },
        { label: "Renewals (Completed)", value: data.renewalsCompleted, color: "#2E7D32" },
        { label: "Termination Requests", value: data.terminationRequests, color: "#F5A623" },
    ];

    return (
        <div style={{ minWidth: "280px", flex: "1 1 280px" }}>
            <p style={{ color: "#2E7D32", fontWeight: 700, marginBottom: "20px",marginTop: "40px" }}>
                As of {formatAsOfDate(data.asOfDate)}
            </p>

            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px", marginTop: "50px" }}>
                <span style={{ fontWeight: 700 }}>Memberships Due for Renewal</span>
                <span style={{ fontWeight: 700 }}>{data.membershipsDueforRenewal}</span>
            </div>

            {rows.map((row) => (
                <div
                    key={row.label}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "10px",
                        marginTop: "20px",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span
                            style={{
                                width: 14,
                                height: 14,
                                background: row.color,
                                display: "inline-block",
                                borderRadius: 2,
                            }}
                        />
                        <span>{row.label}</span>
                    </div>
                    <span>{row.value}</span>
                </div>
            ))}
        </div>
    );
};

const RenewalAnalyticsView = () => {
    const [summaryData, setSummaryData] = useState([]);
    const [summaryLoading, setSummaryLoading] = useState(true);
    const [summaryError, setSummaryError] = useState("");
    const [reloadKey, setReloadKey] = useState(0);
    const [getRenewalAnalyticsOverview,{ data, isLoading, isError }] = useLazyGetRenewalAnalyticsOverviewForReportQuery();

    const fetchRenewalSummary = useCallback(async () => {
        setSummaryLoading(true);
        setSummaryError("");
        try {
            const response = await getRenewalAnalyticsOverview();
            debugger;
            setSummaryData(response?.data[0]);
        } catch (err) {
            console.error(err);
            setSummaryError("Failed to fetch renewal summary");
        } finally {
            setSummaryLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchRenewalSummary();
    }, [fetchRenewalSummary]);

    return (
        <div style={{ padding: "20px", position: "relative" }}>

            <div
                className="iframe-main-card"
                style={{
                    background: "#f2f7ef",
                    borderRadius: "8px",
                    padding: "24px",
                    marginBottom: "24px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "24px",
                    alignItems: "flex-start",
                }}
            >
                <RenewalSummaryStats
                    data={summaryData}
                    loading={summaryLoading}
                    error={summaryError}
                />
                <div style={{ flex: "1 1 300px", minWidth: "300px", background: "transparent" }}>
                    <MetabaseIframe
                        key={`pie-${reloadKey}`}
                        questionId={QUESTION_IDS.pieChart}
                        title="Memberships Due for Renewal (Pie Chart)"
                        height={500}
                    />
                </div>
            </div>

            <div
                className="iframe-main-card"
                style={{
                    background: "#ffffff",
                    borderRadius: "8px",
                    padding: "16px",
                    marginBottom: "24px",
                }}
            >
                <MetabaseIframe
                    key={`expiring-${reloadKey}`}
                    questionId={QUESTION_IDS.expiringTable}
                    title="Membership Expiring/Expired for the year"
                    height={540}
                />
            </div>

            <div
                className="iframe-main-card"
                style={{
                    background: "#ffffff",
                    borderRadius: "8px",
                    padding: "16px",
                }}
            >
                <MetabaseIframe
                    key={`discontinuation-${reloadKey}`}
                    questionId={QUESTION_IDS.discontinuationTable}
                    title="Reasons For Discontinuation"
                    height={630}
                />
            </div>
        </div>
    );
};

export default RenewalAnalyticsView
